<template>
  <b-container class="d-flex align-items-center justify-content-center">
    <div id="login-main" class="spnod-admin__form--main d-flex align-items-center flex-column">
      <h3 class="h3 mb-4">Payment</h3>
      <PaymentForm />
    </div>
  </b-container>
</template>

<script>
import PaymentForm from '../../components/Forms/PaymentForm'

export default {
  name: 'Payment',
  components: { PaymentForm }
}
</script>



// WEBPACK FOOTER //
// src/app/Pages/AdminAuth/Payment.vue?b62fcd20